import { useCallback, useEffect, useState } from 'react';
import { checkLeadFormByEmail, TGetLeadFormByEmailInput, TCheckLeadFormByEmailResponse } from 'api/ppaLeadForm';
import { message } from 'antd';

const useCheckLeadFormByEmail = (email: string): [TCheckLeadFormByEmailResponse | undefined, boolean, () => Promise<void>] => {
    const [data, setData] = useState<TCheckLeadFormByEmailResponse>();
    const [loading, setLoading] = useState(true);

    const fetch = useCallback(async () => {
        if (!email) {
            return;
        }

        try {
            setLoading(true);
            const res = await checkLeadFormByEmail({ email });
            if (res && !res.error) {
                setData(res.data?.data);
            } else {
                message.error(res?.error || 'Failed to get Lead Form information');
            }
        } catch (error) {
            console.error('useCheckLeadFormByEmail error:', error);
            message.error('An error occurred while getting Lead Form information');
        } finally {
            setLoading(false);
        }
    }, [email]);

    useEffect(() => {
        fetch();
    }, [fetch]);

    return [data, loading, fetch];
};

export default useCheckLeadFormByEmail;
